<template>
    <div>
        <div class="selectDataBox">

        </div>
        <common-table :limitHeight="true" :table-columns="tableColumns" :url="url" :operate="operate"
            :form-fields="formFields" :permission="permission" :buttons="buttons" :searchs="searchs"
            @returnId="returnId" @addCreateRule="addCreateRule" pageName="budgetRegulation" ref="table"
            @isPageSmall="isPageSmall"></common-table>
        <el-drawer :visible.sync="showAddCreateRulePopup" :size="pageSmall ? '100%' : '55%'" direction="rtl"
            :withHeader="false">
            <div class="addCreateRuleBox ">
                <div class="createRuleTitle flex-between alcenter fs18">
                    创建规则
                    <i class="el-icon-close" @click="closeRulePopup"></i>
                </div>
                <div class="setRuleContent">
                    <div class="monitorWayBox">
                        <div class="pb10 ">
                            <span class="fs18 font-bold  pr10">监控方式</span>
                        </div>
                        <div class=" flex-between">
                            <div class="way_box text-center" :class="{ 'active_way_box': activeWayBoxIndex == index }"
                                v-for="(item, index) in monitorWayList" :key="index" @click="goSelectMonitorWay(index)">
                                <div class="font-bold">
                                    {{ item.wayName }}
                                </div>
                                <div class="way_info pt10" :class="{ 'active_way_box': activeWayBoxIndex == index }">
                                    {{ item.info }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="monitorTargetBox">
                        <div class="pb10 font-bold">监控目标</div>
                        <div class="monitorTargetContent ">
                            <div>
                                <div class="flex alcenter" v-if="!activeWayBoxIndex">
                                    <el-input v-model="searchKeyWord"
                                        @clear="searchMonitorList = []; isSearching = false" clearable
                                        placeholder="搜索账户名称或ID" size="medium" class="handle-input2  mb-10" />
                                    <el-button class="mb-10 fs18" type="primary" size="small"
                                        @click="goSearchMonitorList(0)">
                                        搜索
                                    </el-button>
                                </div>
                                <div v-else-if="activeWayBoxIndex == 1">
                                    <div class="flex alcenter pb10">
                                        <el-select class="pr10 input250" @change="getDataByAccount(0)"
                                            v-model="selectedAccount" placeholder="请选择账户">
                                            <el-option v-for="(item, index) in accountList" :key="index"
                                                :label="item.name" :value="item.advertiserId">
                                            </el-option>
                                        </el-select>
                                        <el-select disabled class="pr10 input150" v-model="promotionTarget"
                                            placeholder="请选择">
                                            <el-option v-for="(item, index) in promotionTargetList" :key="index"
                                                :label="item" :value="item">
                                            </el-option>
                                        </el-select>

                                        <el-select disabled class="pr10 input150" v-model="adTarget" placeholder="请选择">
                                            <el-option v-for="(item, index) in adTypeList" :key="index" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>

                                        <el-select disabled class="pr10 input150" v-model="promotionWay"
                                            placeholder="请选择">
                                            <el-option v-for="(item, index) in promotionList" :key="index" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>

                                        <el-select disabled class="pr10 input150" v-model="transformTarget"
                                            placeholder="请选择">
                                            <el-option v-for="(item, index) in transformList" :key="index" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>

                                    </div>

                                    <div class="pb20">
                                        <el-date-picker v-model="selectData" type="daterange" align="right"
                                            unlink-panels range-separator="至" start-placeholder="开始日期"
                                            end-placeholder="结束日期" :picker-options="pickerOptions"
                                            format="yyyy 年 MM 月 dd 日" @change="pickData">
                                        </el-date-picker>
                                        <el-input v-model="searchKeyWord"
                                            @clear="searchMonitorList = []; isSearching = false" clearable
                                            placeholder="搜索计划名称或ID" size="medium" class="handle-input2  mb-10 ml10" />
                                        <el-button class="mb-10 fs18" type="primary" size="small"
                                            @click="goSearchMonitorList(1)">
                                            搜索
                                        </el-button>
                                    </div>
                                </div>
                                <div v-else-if="activeWayBoxIndex == 2">
                                    <div class="flex alcenter pb10">
                                        <el-select class="pr10 input250" @change="getDataByAccount(1)"
                                            v-model="selectedAccount" placeholder="请选择账户">
                                            <el-option v-for="(item, index) in accountList" :key="index"
                                                :label="item.name" :value="item.advertiserId">
                                            </el-option>
                                        </el-select>
                                        <el-input v-model="searchKeyWord"
                                            @clear="searchMonitorList = []; isSearching = false" clearable
                                            placeholder="搜索抖音号名称或ID" size="medium" class="handle-input2   ml10" />
                                        <el-button class=" fs18" type="primary" size="small"
                                            @click="goSearchMonitorList(2)">
                                            搜索
                                        </el-button>
                                    </div>
                                    <div class="pb10 c_ffb563">
                                        温馨提示：账户选择仅用于筛选抖音号，并不作为规则的一部分
                                    </div>
                                </div>
                                <div v-else-if="activeWayBoxIndex == 3">
                                    <div class="flex alcenter pb10">
                                        <el-select class="pr10 input250" @change="getdyNumberList(1)"
                                            v-model="selectedAccount" placeholder="请选择账户">
                                            <el-option v-for="(item, index) in accountList" :key="index"
                                                :label="item.name" :value="item.advertiserId">
                                            </el-option>
                                        </el-select>
                                        <el-select class="pr10 input250" @change="getProductList"
                                            v-model="selectedDYNumber" placeholder="请选择抖音号">
                                            <el-option v-for="(item, index) in dyNumberList" :key="index"
                                                :label="item.name" :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <el-input v-model="searchKeyWord"
                                            @clear="searchMonitorList = []; isSearching = false" clearable
                                            placeholder="搜索商品名称或ID" size="medium" class="handle-input2   ml10" />
                                        <el-button class=" fs18" type="primary" size="small"
                                            @click="goSearchMonitorList(3)">
                                            搜索
                                        </el-button>
                                    </div>
                                    <div class="pb10 c_ffb563">
                                        温馨提示：账户选择仅用于筛选商品，并不作为规则的一部分
                                    </div>
                                </div>
                            </div>
                            <div class="selectAccountBox">
                                <div class="selectTitleBox flex alcenter">
                                    <div class="leftTitle flex alcenter">
                                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                                            @change="handleCheckAllChange">
                                        </el-checkbox>
                                        <span class="pr5 pl10">请选择{{ activeWayBoxIndex ? activeWayBoxIndex == 1 ? '计划'
                                            :
                                            activeWayBoxIndex == 2 ? '抖音号' : '商品' : '账户'
                                        }}</span> <span v-if="monitorList.length" class="pr5">({{ monitorList.length
                                            }})</span>
                                        <el-tooltip class="item" effect="dark"
                                            :content="activeWayBoxIndex ? activeWayBoxIndex == 2 ? '最多展示前200条，如果列表没有某条数据，请使用搜索减小范围' : '最多展示前100条，如果列表没有某条数据，请使用搜索减小范围' : '最多展示前200条，如果列表没有某条数据，请使用搜索减小范围'"
                                            placement="top">
                                            <i class="el-icon-question mt5"></i>
                                        </el-tooltip>
                                    </div>
                                    <div class="rightTitle flex-between">
                                        <div class="flex alcenter">
                                            已选 <span v-if="selectedMonitorList.length">( {{ selectedMonitorList.length
                                                }}
                                                )</span>
                                            <span v-else>{{ activeWayBoxIndex ? activeWayBoxIndex == 1 ? '计划'
                                                :
                                                activeWayBoxIndex == 2 ? '抖音号' : '商品' : '账户' }}</span>
                                        </div>
                                    </div>
                                    <div class="c_primary" v-if="selectedMonitorList.length"
                                        @click="deleteSelectedMonitorList('')">
                                        清空
                                    </div>
                                </div>
                                <div class="selectContentBox">
                                    <div class="flex">
                                        <div class="left">
                                            <el-checkbox-group v-model="checkedAccount"
                                                @change="handleCheckedCitiesChange">
                                                <div class="flex alcenter  pb20"
                                                    v-for="(item, index) in isSearching ? searchMonitorList : monitorList"
                                                    :key="index">
                                                    <el-checkbox :label="item" class="checkBox">
                                                        <div class="pl5 flex alcenter">
                                                            <img class="productImg" v-if="activeWayBoxIndex == 3"
                                                                :src="item.img" alt="">
                                                            <div class="pl10">
                                                                <div class="fs18  overflow1_300 h20">{{ item.name ||
                                                                    item.productName }}</div>
                                                                <div class="c_999 fs14">
                                                                    ID:{{ activeWayBoxIndex ? activeWayBoxIndex == 1 ?
                                                                        item.adId : activeWayBoxIndex == 2 ? item.id
                                                                            : item.id : item.advertiserId }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </el-checkbox>
                                                </div>
                                            </el-checkbox-group>
                                            <div class="pt50 nodata flex-center"
                                                v-if="isSearching ? !searchMonitorList.length : !monitorList.length">
                                                暂无数据
                                            </div>
                                        </div>
                                        <div class="left p5">
                                            <div class="flex-between alcenter selectedAccountBox pb20 mb10"
                                                v-for="(item, index) in selectedMonitorList" :key="index">
                                                <div class="pl5 flex alcenter">
                                                    <img class="productImg" v-if="activeWayBoxIndex == 3"
                                                        :src="item.img" alt="">
                                                    <div class="pl10">
                                                        <div class="fs18 overflow1_300">{{ item.name || item.productName
                                                        }}
                                                        </div>
                                                        <div class="c_999 fs14">
                                                            ID:{{ activeWayBoxIndex ? activeWayBoxIndex == 1 ?
                                                                item.adId : activeWayBoxIndex == 2 ? item.id
                                                                    : item.id : item.advertiserId }}
                                                        </div>
                                                    </div>

                                                </div>
                                                <i class="el-icon-error" @click="deleteSelectedMonitorList(index)"></i>
                                            </div>
                                            <div class="pt50 nodata flex-center" v-if="!selectedMonitorList.length">
                                                暂无数据
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!-- <div class="pt10 pb10" v-if="activeWayBoxIndex !== 2">
                                计划维度筛选
                            </div>
                            <div>
                                <div class="flex alcenter" v-if="!activeWayBoxIndex">
                                    <el-select class="mr10" v-model="marketingValue" placeholder="请选择">
                                        <el-option v-for="item in marketingList" :key="item" :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                    <el-select class="mr10" v-model="adTypeValue" placeholder="请选择">
                                        <el-option v-for="item in adTypeList" :key="item" :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                    <el-select class="mr10" v-model="promotionValue" placeholder="请选择">
                                        <el-option v-for="item in promotionList" :key="item" :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                    <el-select class="mr10" v-model="transformValue" placeholder="请选择">
                                        <el-option v-for="item in transformList" :key="item" :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="flex alcenter" v-else-if="activeWayBoxIndex == 1">

                                    <el-select class="mr10" v-model="transformValue" placeholder="请选择">
                                        <el-option v-for="item in transformList" :key="item" :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="flex alcenter" v-else-if="activeWayBoxIndex == 3">
                                    <el-select class="mr10" v-model="marketingValue" placeholder="请选择">
                                        <el-option v-for="item in marketingList" :key="item" :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                    <el-select class="mr10" v-model="adTypeValue" placeholder="请选择">
                                        <el-option v-for="item in adTypeList" :key="item" :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                    <el-select class="mr10" v-model="promotionValue" placeholder="请选择">
                                        <el-option v-for="item in promotionList" :key="item" :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                    <el-select class="mr10" v-model="transformValue" placeholder="请选择">
                                        <el-option v-for="item in transformList" :key="item" :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="flex alcenter" v-else-if="activeWayBoxIndex == 4">
                                    <el-select class="mr10" v-model="adTypeValue" placeholder="请选择">
                                        <el-option v-for="item in adTypeList" :key="item" :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                    <el-select class="mr10" v-model="promotionValue" placeholder="请选择">
                                        <el-option v-for="item in promotionList" :key="item" :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                    <el-select class="mr10" v-model="transformValue" placeholder="请选择">
                                        <el-option v-for="item in transformList" :key="item" :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div> -->

                        </div>
                    </div>
                    <div class="monitorTargetBox ">
                        <div class="pb10 fs18 font-bold">执行内容</div>
                        <div class="monitorTargetContent ">
                            <div class=" input100 ">
                                <div class="flex  pt20">
                                    <div class="pr20  pt5 ">
                                        执行条件
                                    </div>
                                    <div class="">
                                        <div class="flex alcenter">
                                            <el-select class="input150 mr5" v-model="executionValue" placeholder="请选择">
                                                <el-option v-for="(item, index) in executionList" :key="index"
                                                    :label="item.name" :value="index" :disabled="item.disabled">
                                                </el-option>
                                            </el-select>
                                            <el-select class="input100 mr5"
                                                v-model="executionList[executionValue].compare" disabled
                                                placeholder="请选择">
                                                <el-option v-for="(item, index) in compareList" :key="index"
                                                    :label="item.name" :value="item.name" :disabled="item.disabled">
                                                </el-option>
                                            </el-select>
                                            <div class="relative input150">
                                                <el-input min="0" type="number" v-model="consumeMin" placeholder="请输入"
                                                    suffix-icon="元" size="medium" />
                                                <div class="yuan_box">
                                                    {{ executionList[executionValue].symbol }}
                                                </div>
                                            </div>
                                            <span class="pl10 pr10">
                                                且满足以下
                                            </span>
                                            <el-select class="input100 mr5" v-model="conditionValue" placeholder="请选择">
                                                <el-option v-for="(item, index) in conditionList" :key="index"
                                                    :label="item" :value="item">
                                                </el-option>
                                            </el-select>
                                            条件
                                        </div>
                                        <div class="flex alcenter pt20 "
                                            v-for="(condition, index) in executeConditionList" :key="index">
                                            <el-select class="input150 mr5" v-model="condition.ordersValue"
                                                placeholder="请选择" @change="executeConditionChange($event, index)">
                                                <el-option v-for="(item, ind) in executionList" :key="ind"
                                                    :label="item.name" :value="ind" :disabled="!item.disabled">
                                                </el-option>
                                            </el-select>
                                            <el-select class="input100 mr5" v-model="condition.compareValue"
                                                placeholder="请选择">
                                                <el-option v-for="(item, ind) in compareList" :key="ind" :label="item"
                                                    :value="item">
                                                </el-option>
                                            </el-select>
                                            <div class="relative input150 input_h40">
                                                <el-input min="0" type="number" :disabled="!condition.ordersValue"
                                                    v-model="condition.consumeMoney" placeholder="请输入" suffix-icon="元"
                                                    size="medium" />
                                                <div class="yuan_box" v-if="executionList[condition.ordersValue]">
                                                    {{ executionList[condition.ordersValue].symbol }}
                                                </div>
                                            </div>
                                            <i @click="goDeleteCondition(index, condition.choosedIndex)"
                                                class="el-icon-delete c_primary ml30"
                                                v-if="executeConditionList.length > 1"></i>
                                        </div>

                                        <div class="addCondition flex-center mt20" @click="addCondition"
                                            v-if="executeConditionList.length < 9">
                                            + 增加条件
                                        </div>
                                    </div>
                                </div>
                                <div class="flex  pt20">
                                    <div class="pr10 pt5">
                                        执行动作
                                    </div>
                                    <el-select class="input150 mr5" v-model="actionValue" placeholder="请选择">
                                        <el-option v-for="(item, index) in actionList" :key="index" :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="flex  pt20 alcenter">
                                    <div class="pr50 pt5">
                                        预算
                                    </div>
                                    <el-select class="input150" v-model="budgetValue" placeholder="请选择">
                                        <el-option v-for="(item, index) in budgetList" :key="index" :label="item"
                                            :value="item">
                                        </el-option>
                                    </el-select>
                                    <div class="relative  input_h40">
                                        <el-input class="input150" min="0" v-model="budgetNumber" type="number"
                                            placeholder="请输入" suffix-icon="元" size="medium" />
                                        <div class="yuan_box">
                                            {{ budgetValue == '百分比提高' ? '%' : '元' }}
                                        </div>
                                    </div>
                                    <el-tooltip v-if="budgetValue == '百分比提高'" class="item ml10" effect="dark"
                                        content="官方限制预算修改幅度不能低于100元，如果低于100元则按100元进行提高" placement="top">
                                        <i class="el-icon-question mt5"></i>
                                    </el-tooltip>
                                </div>
                                <div class="flex  pt20" v-if="budgetValue !== '修改为'">
                                    <div class="pr50 pt5">
                                        单计划最高预算
                                    </div>
                                    <div class="relative input150">
                                        <el-input v-model="maxbudgetNumber" min="0" type="number" placeholder="请输入"
                                            suffix-icon="元" size="medium" />
                                        <div class="yuan_box">
                                            元
                                        </div>
                                    </div>
                                </div>
                                <div class="flex  pt20">
                                    <div class="pr50 pt5">
                                        单计划每日最多调整上限
                                    </div>
                                    <div class="relative input150">
                                        <el-input v-model="adjustNumber" min="0" type="number" placeholder="请输入"
                                            suffix-icon="元" size="medium" />
                                        <div class="yuan_box">
                                            次
                                        </div>
                                    </div>
                                </div>
                                <div class="flex  pt20">
                                    <span class="pr10 pt5 ">
                                        执行时段
                                    </span>
                                    <div>
                                        <div class="flex alcenter">
                                            <div class="timePeriodBox" @click="activeTimePeriodBox = 0"
                                                :class="{ 'activeTimePeriodBox': !activeTimePeriodBox }">
                                                不限
                                            </div>
                                            <div class="timePeriodBox" @click="activeTimePeriodBox = 1"
                                                :class="{ 'activeTimePeriodBox': activeTimePeriodBox }">
                                                指定时段
                                            </div>
                                        </div>
                                        <div class="pt10" v-if="activeTimePeriodBox">
                                            <table border class="yl-time-range-table">
                                                <thead class="table_head">
                                                    <tr>
                                                        <th colspan="24">00:00 - 12:00</th>
                                                        <th colspan="24">12:00 - 24:00</th>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2" v-for="(item, index) in 24" :key="index"> {{
                                                            item -
                                                            1
                                                        }}
                                                        </td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td colspan="1" class="" v-for="(item, index) in 47"
                                                            :key="index">
                                                            <div class="time_select_box"
                                                                :class="timeSelectActiveList.includes(item - 1) ? 'time_select_box_active' : 'time_select_box_inactive'"
                                                                @click="selectTimeBox(item - 1)">
                                                                <div class="trigger" style="display: inline-block;">
                                                                    <div class="yl-time-range-triger">
                                                                        <!-- {{ item }} -->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="c_ff3939 pt10" v-if="timeSelectActiveList.length">
                                            请选择时间
                                        </div>
                                    </div>
                                </div>

                                <div class="flex alcenter  pt20" v-if="actionValue == '调整且通知'">
                                    <span class="pr20 ">
                                        通知方式
                                    </span>
                                    <div>
                                        <el-checkbox :style="{ 'transform: scale(1.2);': !pageSmall }"
                                            v-model="wxNotice">
                                            微信通知
                                        </el-checkbox>
                                        <div v-if="!wxNotice" class="c_ff3939 pt10">
                                            请选择通知方式
                                        </div>
                                    </div>
                                </div>
                                <div class="flex  pt20" v-if="wxNotice && actionValue == '调整且通知'">
                                    <span class="pr10 pt10">
                                        微信联系人
                                    </span>
                                    <div>
                                        <div>
                                            <el-select :class="pageSmall ? 'input200' : 'w400 input400'" multiple
                                                v-model="wxContracts" filterable placeholder="请选择联系人">
                                                <el-option v-for="item in wxContractsOptions" :key="item.wechatName"
                                                    :label="item.wechatName" :value="item.openId">
                                                </el-option>
                                            </el-select>
                                            <span class="pl20 c_primary" @click="goAddContrats">添加联系人</span>
                                        </div>
                                        <div class="flex alcenter flex_wrap pt10">
                                            <el-switch class="mr10" :style="{ 'transform: scale(1.1);': !pageSmall }"
                                                v-model="isLimitWXNotice">
                                            </el-switch>
                                            限制通知频率，每条计划
                                            <el-select v-model="wxNoticeTimeValue" :disabled="!isLimitWXNotice"
                                                class="ml5 input150" placeholder="请选择" :class="pageSmall ? 'mt20' : ''">
                                                <el-option v-for="(item, index) in wxNoticeTimeList" :key="index"
                                                    :label="item.name" :value="item.value">
                                                </el-option>
                                            </el-select>
                                            <div :class="pageSmall ? 'mt20' : ''">
                                                内最多通知一次
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="p30 pt5">
                        <span class="font-bold">监控状态</span>
                        <el-select class="pl10 input250" v-model="monitorStatus" placeholder="请选择">
                            <el-option v-for="item in monitorStatusList" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="p30  pt5 flex alcenter">
                        <span class="font-bold pr10">规则名称</span>
                        <el-input class="input250 w300" v-model="ruleName" placeholder="请输入规则名称" />
                    </div>
                </div>
                <div class="drawer_footer flex-end alcenter">
                    <el-button class="mb-10 fs18" round type="primary" size="small" @click="closeRulePopup">
                        取消
                    </el-button>
                    <el-button class="mb-10 fs18" round type="primary" size="small" @click="goAddRule">
                        确定
                    </el-button>
                </div>
            </div>
        </el-drawer>

    </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import request from "@/utils/axios";
import message from "@/utils/message";

export default {
    name: 'budgetRegulation',
    components: { CommonTable },
    data() {
        return {
            editData: {},
            // 监控方式
            searchKeyWord: null,
            pickerOptions: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setHours(0, 0, 0, 0);  // 今天00:00:00
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const end = new Date();
                        end.setDate(end.getDate() - 1);
                        end.setHours(23, 59, 59, 999);  // 昨天23:59:59.999
                        const start = new Date(end);
                        start.setHours(0, 0, 0, 0);  // 昨天00:00:00
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '近3天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(start.getDate() - 2);  // 3天前（含今天）
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '近7天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(start.getDate() - 6);  // 7天前（含今天）
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '近15天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(start.getDate() - 14);  // 15天前（含今天）
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '近30天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(start.getDate() - 29);  // 30天前（含今天）
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '上周',
                    onClick(picker) {
                        const today = new Date();
                        const day = today.getDay(); // 本周的第几天（0=周日）
                        const diff = day === 0 ? 6 : day - 1; // 到上周一的天数差

                        const end = new Date(today);
                        end.setDate(today.getDate() - diff - 1); // 上周日
                        end.setHours(23, 59, 59, 999);

                        const start = new Date(end);
                        start.setDate(end.getDate() - 6); // 上周一
                        start.setHours(0, 0, 0, 0);

                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '本月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(1);  // 本月1号
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '上月',
                    onClick(picker) {
                        const end = new Date();
                        end.setMonth(end.getMonth(), 0);  // 上月最后一天
                        end.setHours(23, 59, 59, 999);

                        const start = new Date(end);
                        start.setDate(1);  // 上月1号
                        start.setHours(0, 0, 0, 0);

                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            selectData: '',
            isSearching: false,
            selectedDYNumber: '',
            dyNumberList: [],
            pageSmall: false,

            // 通知方式
            wxNotice: true,
            wxContracts: [],
            wxContractsOptions: [],
            isLimitWXNotice: false,
            wxNoticeTimeValue: 30,
            wxNoticeTimeList: [{
                name: '每30分钟',
                value: 30
            }, {
                name: '每1小时',
                value: 60
            }, {
                name: '每3小时',
                value: 180
            }, {
                name: '每6小时',
                value: 360
            }],

            // 监控目标
            marketingValue: '营销目标：不限',
            marketingList: ['营销目标：不限', '推商品', '推直播间'],
            adTypeValue: '广告类型：不限',
            adTypeList: ['广告类型：不限', '通投广告', '搜索广告', '商城广告'],
            promotionValue: '推广方式：不限',
            promotionList: ['推广方式：不限', '托管计划', '自定义'],
            transformValue: '转化目标：不限',
            transformList: ['转化目标：不限', '商品购买', '粉丝提升', '点赞评论', '直播间成交', '直播间商品点击', '直播间下单', '支付ROI', '直播间粉丝提升', '直播间结算', '结算ROI'],



            // 执行内容
            executionValue: 0,
            ordersValue: '',
            executeConditionList: [{}],
            executionList: [{
                name: '消耗占比',
                disabled: false,
                compare: '大于',
                symbol: '%'
            }, {
                name: '剩余预算',
                disabled: false,
                compare: '小于',
                symbol: '元'
            }, {
                name: '消耗金额',
                disabled: false,
                compare: '大于',
                symbol: '元'
            }, {
                name: 'ROI',
                disabled: true,
                compare: '大于',
                symbol: ''
            }, {
                name: '7日总支付ROI',
                disabled: true,
                compare: '大于',
                symbol: ''
            }, {
                name: '点击率',
                disabled: true,
                compare: '大于',
                symbol: '%'
            }, {
                name: '转化数',
                disabled: true,
                compare: '大于',
                symbol: ''
            }, {
                name: '转化成本',
                disabled: true,
                compare: '大于',
                symbol: '元'
            }, {
                name: '平均千次展现费用',
                disabled: true,
                compare: '大于',
                symbol: '元'
            }, {
                name: '平均点击单价',
                disabled: true,
                compare: '大于',
                symbol: '元'
            }, {
                name: '直接成交订单数',
                disabled: true,
                compare: '大于',
                symbol: ''
            }, {
                name: '直接成交金额',
                disabled: true,
                compare: '大于',
                symbol: '元'
            },],
            conditionValue: '所有',
            conditionList: ['任一', '所有'],
            compareValue: '',
            compareList: ['小于', '大于'],
            consumeMoney: null,
            actionValue: '仅调整',
            actionList: ['调整且通知', '仅调整'],
            budgetValue: '提高',
            budgetList: ['提高', '百分比提高', '修改为'],
            budgetNumber: null,
            maxbudgetNumber: null,
            adjustNumber: null,
            consumeMin: '',
            activeWayBoxIndex: 0,
            monitorWayList: [
                {
                    wayName: '账户',
                    info: '监控账户下所有计划'
                },
                // {
                //     wayName: '广告组',
                //     info: '监控广告组下所有计划'
                // },
                {
                    wayName: '计划',
                    info: '监控指定计划'
                },
                {
                    wayName: '抖音号',
                    info: '监控抖音号下的计划'
                },
                {
                    wayName: '商品',
                    info: '监控指定商品下的计划'
                },
            ],
            // 监控目标
            checkAll: false,
            checkedAccount: [],
            monitorList: [],
            selectedMonitorList: [],
            accountList: [],
            promotionTarget: '推广目标：不限',
            promotionTargetList: ['推广目标：不限', '推商品', '推直播间'],
            adTarget: '广告类型：不限',
            promotionWay: '推广方式：不限',
            transformTarget: '转化目标：不限',
            // 执行时段
            activeTimePeriodBox: 0,
            timeSelectActiveList: [],


            // 监控状态
            monitorStatus: '启用',
            monitorStatusList: ['启用', '停用'],

            // 规则名称
            ruleName: '',
            isIndeterminate: true,
            showAddCreateRulePopup: false,
            selectIds: [],
            selectProductIds: [],

            searchs: [
                {
                    name: 'monitorStatus',
                    placeholder: '监控状态',
                    type: 'select',
                    select: true,
                    // selectUrl: '/oceanEngineAdvertiser/getAllInfo',
                    selectData: [],
                    selectValue: [{
                        value: '关闭',
                        key: 0
                    }, {
                        value: '开启',
                        key: 1
                    }]
                }, {
                    name: 'createPerson',
                    placeholder: '创建人',
                    type: 'select',
                    select: true,
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    isGet: true
                },
                {
                    name: 'ruleName',
                    placeholder: '规则名称',
                    type: 'input'
                }],
            permission: {
                add: 'launchTheProduct:add',
                update: 'launchTheProduct:update',
                delete: 'launchTheProduct:delete',
                deleteBatch: 'launchTheProduct:deleteBatch'
            },
            url: {
                // get: '/launchTheProduct/listByCondition',
                // add: '/launchTheProduct/add',
                // update: '/launchTheProduct/update',
                // delete: '/launchTheProduct/delete',
                // delete_batch: '/launchTheProduct/deleteBatch',
                // status: '/launchTheProduct/status',
            },
            tableColumns: [{
                field: 'advertiserId',  // 字段名
                label: '状态',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                status: true,  // 是否展示
            }, {
                field: 'ruleName',  // 字段名
                label: '规则名称',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            }, {
                field: 'monitorWay',  // 字段名
                label: '监控方式',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            }, {
                field: 'ruleInfo',  // 字段名
                label: '规则详情',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                width: 600
            }, {
                field: 'executeAction',  // 字段名
                label: '执行动作',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            }, {
                field: 'createPerson',  // 字段名
                label: '创建人',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,
            }],
            formFields: {
                addTitle: '添加',
                updateTitle: '修改',
                model: [
                    {
                        field: 'id',  // 字段名
                        label: 'ID',  // 字段显示名称
                        type: 'input',
                        add: false,  // 是否添加
                        update: true
                    },
                    {
                        field: 'agentId',  // 字段名
                        label: 'agentId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入agentId',
                        rules: [
                            { required: true, message: 'agentId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'userId',  // 字段名
                        label: 'userId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入userId',
                        rules: [
                            { required: true, message: 'userId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'advertiserId',  // 字段名
                        label: 'advertiserId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入advertiserId',
                        rules: [
                            { required: true, message: 'advertiserId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'aweMeId',  // 字段名
                        label: 'aweMeId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入aweMeId',
                        rules: [
                            { required: true, message: 'aweMeId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'productId',  // 字段名
                        label: 'productId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入productId',
                        rules: [
                            { required: true, message: 'productId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'productName',  // 字段名
                        label: 'productName',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入productName',
                        rules: [
                            { required: true, message: 'productName不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'img',  // 字段名
                        label: 'img',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入img',
                        rules: [
                            { required: true, message: 'img不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'tag',  // 字段名
                        label: 'tag',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入tag',
                        rules: [
                            { required: true, message: 'tag不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'categoryName',  // 字段名
                        label: 'categoryName',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入categoryName',
                        rules: [
                            { required: true, message: 'categoryName不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'sellNum',  // 字段名
                        label: 'sellNum',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入sellNum',
                        rules: [
                            { required: true, message: 'sellNum不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'grayReason',  // 字段名
                        label: 'grayReason',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入grayReason',
                        rules: [
                            { required: true, message: 'grayReason不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'squareImageList',  // 字段名
                        label: 'squareImageList',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入squareImageList',
                        rules: [
                            { required: true, message: 'squareImageList不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelId',  // 字段名
                        label: 'channelId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入channelId',
                        rules: [
                            { required: true, message: 'channelId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelType',  // 字段名
                        label: 'channelType',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入channelType',
                        rules: [
                            { required: true, message: 'channelType不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    },
                ]
            },
            operate: [{
                icon: 'el-icon-edit',
                type: 'text',
                text: '编辑',
                handle: (row) => {
                    console.log(row)
                    // this.resetPwdForm.id = row.id;
                    // this.resetPwdForm.username = row.username;
                    // this.resetPwdVisible = true;
                }
            }, {
                icon: 'el-icon-edit',
                type: 'text',
                text: '删除',
                handle: (row) => {
                    console.log(row)
                    // this.resetPwdForm.id = row.id;
                    // this.resetPwdForm.username = row.username;
                    // this.resetPwdVisible = true;
                }
            }, {
                icon: 'el-icon-edit',
                type: 'text',
                text: '日志',
                handle: (row) => {
                    console.log(row)
                    // this.resetPwdForm.id = row.id;
                    // this.resetPwdForm.username = row.username;
                    // this.resetPwdVisible = true;
                }
            }],
            buttons: [
                {

                }
            ]
        }
    },
    mounted() {
        this.getADAccountList()
        this.getWxcontractsList()
    },
    beforeDestroy() {
    },
    methods: {
        goAddContrats() {
            this.showAddCreateRulePopup = false
            setTimeout(() => {
                this.$router.push({
                    path: '/qdd/admin/contacts.html',
                })
            }, 1)
        },

        getWxcontractsList() {
            this.$axios.post({
                url: '/wechatUser/getAll',
                success: (res) => {
                    // this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.wxContractsOptions = res.data
                    } else {
                        this.$message.error(res.msg || '出错了')
                    }
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
        isPageSmall(data) {
            this.pageSmall = data;
            console.log(this.pageSmall)
        },
        closeRulePopup() {
            this.editData = {}
            this.searchKeyWord = null
            this.selectData = ''
            this.isSearching = false
            this.selectedDYNumber = ''
            this.dyNumberList = []
            this.executionValue = 0
            this.ordersValue = ''
            this.executeConditionList = [{}]
            this.conditionValue = ''
            this.compareValue = ''
            this.consumeMoney = null
            this.actionValue = '仅调整'
            this.budgetValue = '提高'
            this.budgetNumber = null
            this.maxbudgetNumber = null
            this.adjustNumber = null
            this.consumeMin = ''
            this.activeWayBoxIndex = 0

            this.checkAll = false
            this.checkedAccount = []
            this.selectedMonitorList = []
            this.monitorList = this.accountList
            this.activeTimePeriodBox = 0
            this.timeSelectActiveList = []
            this.monitorStatus = '启用'
            this.ruleName = ''
            this.isIndeterminate = true

            this.showAddCreateRulePopup = false
            this.executeConditionList = [{}]
        },
        inputBlur(e, index) {
            console.log(e, index, 'inputBlur')
            if (e <= this.stairsList[index].minValue) {
                this.$set(this.stairsList[index], 'wholePayNum', JSON.parse(this.stairsList[index].minValue) + 0.01)
            }
        },
        ordersChange() {
            // console.log(this.executeConditionList)
            let list = []
            this.executeConditionList.forEach((obj) => {
                list.push(obj.ordersValue)
            })
            this.ordersList.forEach((obj) => {
                if (list.includes(obj.name)) {
                    obj.disabled = true
                    // this.$set(this.ordersList)
                } else {
                    obj.disabled = false

                }
            })
        },
        // 处理选择时间
        pickData(e) {
            console.log(e)
            if (e) {
                console.log(e, '233')
                console.log(this.selectData, '233')
                const year_start = e[0].getFullYear()
                const month_start = String(e[0].getMonth() + 1).padStart(2, '0')
                const day_start = String(e[0].getDate()).padStart(2, '0')
                this.startTime = `${year_start}-${month_start}-${day_start}`
                const inputDate = new Date(e[1])
                this.endTime = this.processDate(inputDate)
                console.log(this.startTime, this.endTime, '233')
            } else {
                this.startTime = ''
                this.endTime = ''
                console.log(this.startTime, this.endTime, '233')
            }
            if (this.selectedAccount) {
                this.getPlanList()
            }
        },
        processDate(targetDate) {
            const now = new Date();
            // 创建目标日期的纯日期部分（去除时间）
            const targetDateOnly = new Date(
                targetDate.getFullYear(),
                targetDate.getMonth(),
                targetDate.getDate()
            );

            // 创建当前日期的纯日期部分（去除时间）
            const todayOnly = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate()
            );

            console.log(targetDateOnly.getTime() === todayOnly.getTime(), now, '555555')
            if (targetDateOnly.getTime() === todayOnly.getTime()) {
                // 如果是今天：返回当前完整时间（年月日时分秒）

                const year = now.getFullYear()
                const month = String(now.getMonth() + 1).padStart(2, '0')
                const day = String(now.getDate()).padStart(2, '0')
                // const hours = String(now.getHours()).padStart(2, '0')
                // const minutes = String(now.getMinutes()).padStart(2, '0')
                // const seconds = String(now.getSeconds()).padStart(2, '0')
                return `${year}-${month}-${day}`
            } else {
                const year_end = targetDate.getFullYear()
                const month_end = String(targetDate.getMonth() + 1).padStart(2, '0')
                const day_end = String(targetDate.getDate()).padStart(2, '0')
                return `${year_end}-${month_end}-${day_end}`
            }
        },
        goAddRule() {
            if (!this.selectedMonitorList.length) {
                let name = this.activeWayBoxIndex ? this.activeWayBoxIndex == 1 ? '计划'
                    :
                    this.activeWayBoxIndex == 2 ? '抖音号' : '商品' : '账户'
                this.$message.error('请选择广告' + name)
                return
            }
            if (this.monitor1) {
                if (this.consumeMin == '' || this.wholePayNum == '' || this.roiImproveNum == '') {
                    this.$message.error('请完善执行条件')
                    return
                }
                if (!Number.isInteger(Number(this.wholePayNum))) {
                    this.$message.error('请输入整数')
                    return
                }


                let index = this.stairsList.findIndex((obj) => obj.wholePayNum == '' || obj.roiImproveNum == '')
                if (index !== -1) {
                    this.$message.error('请完善执行条件')
                    return

                }

                if (this.roiTargetMax == '') {
                    this.$message.error('请完善整体ROI目标最高调整目标')
                    return

                }

                if (this.activeTimePeriodBox) {
                    if (!this.timeSelectActiveList.length) {
                        this.$message.error('请选择时间')
                        return
                    }
                }
            }

            if (this.monitor2) {
                if (this.consumeMax == '' || this.wholePayNum3 == '' || this.roiTargetMin == '') {
                    this.$message.error('请完善执行条件')
                    return
                }
                if (this.isOpenWholePay) {
                    if (this.wholePayNum2 == '') {
                        this.$message.error('请完善执行条件')
                        return
                    }

                }

                if (this.activeTimePeriodBox2) {
                    if (!this.timeSelectActiveList2.length) {
                        this.$message.error('请选择时间')
                        return
                    }
                }

            }

            if (!this.wxNotice) {
                this.$message.error('请选择通知方式')
                return

            }

            if (!this.wxContracts) {
                this.$message.error('请选择联系人')
                return

            }

            if (!this.ruleName) {
                this.$message.error('请输入规则名称')
                return

            }

            let ids = []
            this.selectedMonitorList.forEach((obj) => {
                if (!this.activeWayBoxIndex) {
                    ids.push(obj.advertiserId)
                } else if (this.activeWayBoxIndex == 1) {
                    ids.push(obj.adId)
                } else if (this.activeWayBoxIndex == 2) {
                    ids.push(obj.id)
                } else if (this.activeWayBoxIndex == 3) {
                    ids.push(obj.id)
                }
            })
            let noticeConfig = {  //通知设置，如通知设置传0则为不通知
                wxNumber: this.wxContracts,  //通知微信号
                interval: this.isLimitWXNotice ? this.wxNoticeTimeValue : 0  //限制的通知频率，为0则不限制
            }

            let executeContent = {
                executionValue: this.executionList[this.executionValue].name, //执行条件第一条参数名称  取值范围为  ['消耗占比','剩余预算','消耗占比']
                // name是名称，symbol是对应值符号
                compareValue: this.executionList[this.executionValue].compare,//执行条件第一条符号  取值范围为 ['大于','小于']
                consumeMin: this.consumeMin,//执行条件第一条值大小  
                unit: this.executionList[this.executionValue].symbol,//执行条件第一条值的单位  ['%','元','']
                conditionValue: this.conditionValue,//满足以下条件所有还是任一  取值范围为 ['任一', '所有']
                conditionList: this.executeConditionList, //以下条件list      [{ ordersValue: 'ROI',  compareValue: '大于',consumeMoney: '',unit:'%'}],
                //ordersValue 执行条件参数名称  取值范围为 ['ROI','7日总支付ROI','点击率','转化数','转化成本','平均千次展现费用','平均点击单价','直接成交订单数','直接成交金额'] 
                //compareValue 比较参数  值有  ['大于','小于']
                //consumeMoney 值参数 大小数值
                //unit 值单元  取值有 ['%','元','']
                executeVale: this.actionValue,  // 执行动作值  取值有 ['仅调整','调整且通知']
                improveValue: this.budgetValue,  // 预算参数名称  取值范围为  ['提高', '百分比提高', '修改为']
                budgetNumber: this.budgetNumber, // 预算提高多少 
                maxbudgetNumber: this.maxbudgetNumber,  // 单计划最高预算 
                adjustNumber: this.maxbudgetNumber,  // 单计划每日最多调整上限
                timeSelectActiveList: this.activeTimePeriodBox ? this.timeSelectActiveList : [], // 执行时段
            }
            const now = new Date();
            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')
            const seconds = String(now.getSeconds()).padStart(2, '0')
            let monitoringTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`

            if (this.editData.monitoringTime) {
                executeContent.monitoringTime = this.editData.monitoringTime
            } else {
                executeContent.monitoringTime = monitoringTime
            }
            console.log(executeContent)
            let data = {
                ruleName: this.ruleName,
                marketingTarget: 0,
                monitorType: this.activeWayBoxIndex + 1,
                status: 1,
                monitorObject: ids,
                executeContent: JSON.stringify(executeContent),
                noticeConfig: JSON.stringify(noticeConfig),
                intelligentRegulationType: 2,
                monitorAdvertiserId: this.selectedAccount,
            }
            console.log(data)
            let url
            if (this.editData.id) {
                data.id = this.editData.id
                url = 'smartRoiRules/update'
            } else {
                url = 'smartRoiRules/add'
            }
            this.$axios.post({
                url: url,
                data,
                success: (res) => {
                    // this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.closeRulePopup()
                        this.$refs.table.getData()
                    } else {
                        this.$message.error(res.msg || '出错了')

                    }


                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })


        },
        handleCheckAllChange(e) {
            console.log(e)
            this.checkedAccount = e ? this.monitorList : []
            this.selectedMonitorList = this.checkedAccount
            this.isIndeterminate = false
            console.log(this.isIndeterminate, 'this.isIndeterminate')
        },
        handleCheckedCitiesChange(e) {
            console.log(e)
            this.selectedMonitorList = e
            this.checkAll = e.length === this.monitorList.length
            this.isIndeterminate = e.length > 0 && e.length < this.monitorList.length
        },
        deleteSelectedMonitorList(index) {
            console.log(index, index)
            if (index === '') {
                this.handleCheckAllChange(false)
            } else {
                this.checkedAccount = this.checkedAccount.slice(0, index).concat(this.checkedAccount.slice(index + 1));
                this.selectedMonitorList = this.checkedAccount
            }
            this.checkAll = false
        },
        goSelectMonitorWay(index) {
            this.activeWayBoxIndex = index
            this.monitorList = []
            this.selectedMonitorList = []
            this.selectedAccount = ''
            this.searchKeyWord = ''
            this.isSearching = false
            this.searchMonitorList = []
            this.checkedAccount = []
            this.checkAll = false

            if (!this.activeWayBoxIndex) {
                this.getADAccountList()

            }
        },
        goSearchMonitorList(type) {
            if (!this.searchKeyWord) return
            this.isSearching = true
            this.searchMonitorList = []
            if (!type) {
                this.loadAdvertiserOptions(this.searchKeyWord, (list) => {
                    this.searchMonitorList = list
                })
            } else if (type == 1) {
                this.monitorList.forEach((obj) => {
                    if (obj.name.includes(this.searchKeyWord) || JSON.stringify(obj.adId).includes(this.searchKeyWord)) {
                        this.searchMonitorList.push(obj)
                    }
                })
            } else if (type == 2) {
                this.monitorList.forEach((obj) => {
                    if (obj.name.includes(this.searchKeyWord) || JSON.stringify(obj.id).includes(this.searchKeyWord)) {
                        this.searchMonitorList.push(obj)
                    }
                })
            } else if (type == 3) {
                this.monitorList.forEach((obj) => {
                    if (obj.name.includes(this.searchKeyWord) || JSON.stringify(obj.id).includes(this.searchKeyWord)) {
                        this.searchMonitorList.push(obj)
                    }
                })
            }
            console.log(this.searchMonitorList)

        },
        loadAdvertiserOptions(keyword, callback) {
            this.$axios.post({
                url: '/oceanEngineAdvertiser/optionsByCondition',
                data: {
                    keyword: keyword || '',
                    pageIndex: 1,
                    pageSize: 30
                },
                success: (res) => {
                    if (res.code === 0) {
                        const payload = res.data || {}
                        callback(Array.isArray(payload.content) ? payload.content : [])
                    } else {
                        this.$message.error(res.msg || '获取数据错误')
                    }
                },
                error: () => {
                    this.$message.error('出错了')
                },
            })
        },
        getADAccountList() {
            this.loadAdvertiserOptions('', (list) => {
                this.accountList = list
                this.monitorList = this.accountList
            })
        },
        getDataByAccount(type) {
            if (type) {
                this.getdyNumberList()

            } else {
                this.getPlanList()
            }

        },
        getPlanList() {
            this.monitorList = []
            this.loading = true
            let data = {
                advertiserId: this.selectedAccount,
                smart_bid_type: 'SMART_BID_CUSTOM',
                pageIndex: 1,
                pageSize: 100
            }
            if (this.endTime) {
                data.create_start_date = this.startTime
            }
            if (this.startTime) {
                data.create_end_date = this.endTime
            }
            console.log(data, 'data------')
            this.$axios.post({
                url: 'uniPromotion/listByCondition',
                data,
                success: (res) => {
                    this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.planList = res.data.content
                        this.monitorList = this.planList
                    } else {
                        this.$message.error(res.msg || '出错了')

                    }

                    //          
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
        getProductList(type) {
            this.checkAll = false
            this.selectedMonitorList = []
            this.searchKeyWord = ''
            this.isSearching = false
            this.searchMonitorList = []
            this.monitorList = []
            this.loading = true
            console.log(this.selectedAccount, this.selectedDYNumber)
            let object = {
                advertiserId: this.selectedAccount,
                aweMeId: this.selectedDYNumber,
                isAll: true,
            }
            console.log(object)
            this.$axios.post({
                url: '/launchTheProduct/getProductList',
                data: object,
                success: (res) => {
                    this.loading = false
                    console.log(res);
                    if (res.code === 0) {
                        console.log(res)
                        this.monitorList = res.data.productList
                        if (type) {
                            this.getdyNumberList(1)
                        }
                    } else {
                        this.$message.error(res.msg)
                        this.loading = false
                    }
                }
            })

        },
        getdyNumberList(type) {
            if (!type) {
                this.monitorList = []
            }

            this.loading = true
            this.$axios.get({
                url: '/oceanEngineAdvertiser/getAllInfoAndDouYin/' + this.selectedAccount,
                success: (res) => {
                    console.log(res, '222')
                    this.loading = false
                    if (res.code === 0) {
                        if (type) {
                            this.dyNumberList = res.data
                            return
                        }
                        this.monitorList = res.data
                    } else {
                        this.$message.error(res.msg || '获取数据错误')
                    }
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
        goSetStairsList() {
            if (!this.wholePayNum || this.wholePayNum == 0) return
            if (!this.stairsList.length) {
                let data = {
                    minValue: this.wholePayNum,
                    wholePayType: this.wholePayValue,
                    wholePayNum: '',
                    improveValue: '百分比提高',
                    roiImproveNum: '',
                }
                this.stairsList.push(data)
            } else {
                let endObj = this.stairsList[this.stairsList.length - 1]
                if (!endObj.wholePayNum || endObj.wholePayNum == 0) return
                let data = {
                    minValue: endObj.wholePayNum,
                    wholePayType: this.wholePayValue,
                    wholePayNum: '',
                    improveValue: '百分比提高',
                    roiImproveNum: '',
                }
                this.stairsList.push(data)

            }
        },
        goDelteteStairsList() {
            this.stairsList.pop()
        },
        addCondition() {
            this.executeConditionList.push({})
        },
        goDeleteCondition(index, choosedIndex) {
            this.executeConditionList.splice(index, 1)
            if (choosedIndex) {
                this.$set(this.executionList[choosedIndex], 'disabled', true)
            }
            console.log(this.executionList, 'obj==')
        },
        executeConditionChange(listIndex, index) {
            this.$set(this.executionList[listIndex], 'disabled', false)
            this.$set(this.executeConditionList[index], 'choosedIndex', JSON.stringify(listIndex))
            console.log(this.executionList, 'obj==')
            // console.log(obj, 'obj==')
        },
        selectTimeBox(num) {
            if (!this.timeSelectActiveList.includes(num)) {
                this.timeSelectActiveList.push(num)
            } else {
                let index = this.timeSelectActiveList.findIndex((obj) => obj == num)
                this.timeSelectActiveList.splice(index, 1)
            }
        },
        returnId(data) {
            this.selectIds = data;
            console.log(this.selectIds)
        },
        addCreateRule() {
            this.showAddCreateRulePopup = true;
        },
        submitBatch(formName) {
            // console.log(this.batchForm, "123123")
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    request.post({
                        url: '/launchTheProduct/getAweMeProduct',
                        data: this.updateForm,
                        success: (res) => {
                            if (res.code === 0) {
                                message.success("更新全域计划成功");
                                this.visible = false;
                                this.$refs.table.getData()
                            } else {
                                message.error(res.msg);
                            }
                        }
                    })
                }
            })
        },
        submitCreatBatch(formName) {
            // console.log(this.batchForm, "123123")
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    request.post({
                        url: '/launchTheProduct/createTask',
                        data: this.creatForm,
                        success: (res) => {
                            if (res.code === 0) {
                                message.success("更新全域计划成功");
                                this.creatVisible = false;
                                this.$refs.table.getData()
                            } else {
                                message.error(res.msg);
                            }
                        }
                    })
                }
            })
        },
        submitCreatTaskBatch(formName) {
            // console.log(this.batchForm, "123123")
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    request.post({
                        url: '/launchTheProduct/createTask',
                        data: this.creatTaskForm,
                        success: (res) => {
                            if (res.code === 0) {
                                message.success("更新全域计划成功");
                                this.creatTaskVisible = false;
                                this.$refs.table.getData()
                            } else {
                                message.error(res.msg);
                            }
                        }
                    })
                }
            })
        },
        handleAdvertiserChange() {
            // 清空当前抖音账号选择
            this.updateForm.douyinId = '';
            request.get({
                url: '/oceanEngineAdvertiser/getAllInfoAndDouYin/' + this.updateForm.advertiserId,
                success: (res) => {
                    console.log(res.data, '-----------')
                    if (res.code === 0) {
                        this.currentDouyinList = res.data;
                    } else {
                        message.error(res.msg);
                    }
                }
            })
        },

        handleCreatAdvertiserChange() {
            // 清空当前抖音账号选择
            this.creatForm.douyinId = '';
            request.get({
                url: '/oceanEngineAdvertiser/getAllInfoAndDouYin/' + this.creatForm.advertiserId,
                success: (res) => {
                    // console.log(res.data,'-----------')
                    if (res.code === 0) {
                        this.currentDouyinList = res.data;
                    } else {
                        message.error(res.msg);
                    }
                }
            })
        },
        handleCreatTaskChange() {
            // 清空当前抖音账号选择
            this.creatTaskForm.douyinId = '';
            request.get({
                url: '/oceanEngineAdvertiser/getAllInfoAndDouYin/' + this.creatTaskForm.advertiserId,
                success: (res) => {
                    // console.log(res.data,'-----------')
                    if (res.code === 0) {
                        this.currentDouyinList = res.data;
                    } else {
                        message.error(res.msg);
                    }
                }
            })
        },
    }
}
</script>

<style scoped>
* {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
}

.createRuleTitle {
    background-color: #f9f9f9;
    padding: 15px 30px;
    font-weight: 600;
}

.createRuleTitle i {
    cursor: pointer;
}

.setRuleContent {
    overflow: scroll;
    height: 90vh;
}


/* 营销目标 */

.marketingBox {
    padding: 8px 20px;
    color: #ddd;
    cursor: not-allowed;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-left: none;
    border-radius: 0 5px 5px 0;
}

.marketingObjectives_box div:first-child {
    border-radius: 5px 0 0 5px;
}

.activeMarketingBox {
    background-color: #409eff;
    color: #fff;
}



.monitorWayBox,
.monitorTargetBox {
    padding: 30px;
}

.monitorWayBox i {
    color: #409eff;
}

.monitorWayBox .way_box {
    cursor: pointer;
    width: 220px;
    /* height: 80px; */
    padding: 20px 0;
    border: 1px solid #ddd;
    color: #333;
    border-radius: 5px;
}

.monitorWayBox .way_info {
    color: #666;
}

.active_way_box {
    border-color: #346bf6 !important;
    color: #346bf6 !important;
}

.monitorTargetBox .monitorTargetContent {
    background-color: #f9f9f9;
    border-radius: 5px;
    padding: 15px;
}


/deep/ .monitorTargetBox .monitorTargetContent .el-button {
    border-radius: 0 50px 50px 0;
    height: 36px;
    width: 70px;
}

.handle-input2 {
    width: 300px !important;
}


.selectTitleBox .leftTitle,
.rightTitle {
    font-size: 17px !important;
    /* font-weight: 600 !important; */
    width: 50%;
    background-color: #f0f2f5;
    border: 1px solid #d9d9d9;
    padding: 5px 10px;
}

.selectContentBox {
    background-color: #fff;
    border-left: 1px solid #d9d9d9;
    border-right: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
}

.selectContentBox .accountBox {
    height: 30px;
}

.selectContentBox .left {
    width: 50%;
    padding: 10px;
    height: 250px;
    overflow: scroll;
}

.selectContentBox .left:first-child {
    border-right: 1px solid #d9d9d9;
}

.selectContentBox .nodata {
    /* width: 100%; */
    padding: 10px;
    height: 90%;
}

.selectedAccountBox {
    background-color: #edf4ff;
    padding: 10px;
}


.productImg {
    height: 50px;
    width: 50px;
    border-radius: 5px;
}

.selectedAccountBox i {
    color: #409eff;
    cursor: pointer;
}

.yuan_box {
    position: absolute;
    top: 5px;
    right: 5px;
}

.addCondition {
    background-color: #edf4ff;
    padding: 5px 0;
    width: 500px;
    color: #4389f9;
    cursor: pointer;
}

.w100 {
    width: 100px;
}

.w150 {
    width: 150px;
}



.yl-time-range-table {
    border-collapse: collapse;
    table-layout: fixed;
    -webkit-user-select: none;
    user-select: none;
    border-radius: 4px;
    width: 573px;
    border: 1px solid #e4e9ed;
    background-color: #fff;
}

.table_head {
    background-color: #f0f2f5;
    color: #555;
    /* padding: 10px; */
    text-align: center;
}

.time_select_box {
    cursor: pointer;
}

.time_select_box_inactive:hover {
    background-color: #f0f2f5;
}

.time_select_box_active {
    background-color: #409eff;
}

.drawer_footer {
    z-index: 1;
    background: #fff;
    align-items: center;
    height: 64px;
    padding: 0 20px;
    display: flex;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0 -4px 6px #00000014;
}

.currentPeriodBox {
    background-color: #e5ebf9;
    padding: 5px 10px;
    border-radius: 5px;
}

.timePeriodBox {
    border: 1px solid #ddd;
    padding: 5px 30px;
    color: #555;
    cursor: pointer;
}

.activeTimePeriodBox {
    background-color: #409eff;
    color: #fff;
}


.exUserBox {
    border: 1px solid #ccc;
    height: 250px;
    box-sizing: border-box;
    /* padding-top: 50px; */
    /* overflow: scroll; */
    width: 500px;
    background-color: #fff;

}

.exUserBox .topTitle {
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    background-color: #e4eeff;
    border-bottom: 1px solid #ccc;
}

.exUserBox .topTitle div {
    width: 250px;
    height: 50px;
    /* padding-left: 20px; */
    text-align: center;
    box-sizing: border-box;
    line-height: 50px;
}

.exUserBox .topTitle div:first-child {
    border-right: 1px solid #ccc;
}

.qrcodeBox {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMQAAADECAMAAAD3eH5ZAAAAVFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA5OTlxcXEAAABmZmZ2dnaQkJCOjo7x8fH09PSXl5f6+vr8/Pz+/v7///+YmJj///+ZmZn///+SQT0dAAAAGnRSTlMAAQIDBAUGBwgJCQkKCg0+P1pfkZat4OPu+FYhr8AAAALxSURBVHja7d1Lc6swDAVgEiSZtukjTdqk4v//z7vgZYxNMncBsuecdcLoG9ksOVVVaA6mk/v8z0gOWaUAQpyR/Olx9zytMDn9Q8u64Wg0a4o0oTaRNCNlsDX/UpJQRAjDP8lEAkcMsTSEAN4tISSpCA2TgM1kcoSKBWI0jAIxkdERUcQMHqF7gNs9I8RnBIqYoSd0D2l2zQTpGAvFDDEZOoI3/8tu8SQDI1TEEO+Xu6Zy2izJEe6X9xVEb6CLptNulpUhLjRXBIuo65rorl/izrfWYG5nJ196p17hrWK2CCJWlddrazTXV1FlonAVwSJY1Zk1tO3V9Yg6iSBiVj23hnNW5WEVIWJchKjeLCNuqhKsYo4gYpYt30H/996SYBULhOSAkDiiP03M4uwjnDD752mGIGLJAzFfRZkIlwPCrSGYxTX2EU1/KZaI4TTlgRhWURzCuxJZIOaXokxEkwOiKR3BLK55sY94Cd6xQAABBBBAbIk4tcZzAgIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggACiVAS+UgoEEEBYQ+Bb+5YQ6J/YF4FOFkOIIip+iilbQneXEUTuVXBFlPIVVI+Ye1FlEZWhxZS35l+jO65CVSwXGotqpNA4rJZWZRH38f3z+2cJ8Pf78/3hRFg1Ui0dlnzf9bPvKZ86yk+7Zeor77vKP/X+RFP5Wsn3djXrayXfa4he8bZSt75d3f1K3frbWvH9uIuaiIiZRaQ7Vzunm4OZiZa19z0iUPiMAbJ3mAPCwuAhJkVNo8NEaCCEhgiiU3SMzrEzZpqhngi+YUBEFD3Dh+yZYZpj2jBDjIzRYSXHCMFDBIqRYUbiDXRIGRYKn2EqhxXDUmEQEhmxqh4qrFiSo1XV0wqzqWIpgJCVo3qY3OfPM/8ACadI/HzwP7wAAAAASUVORK5CYII=) no-repeat;
    justify-content: center;
    align-items: center;
    width: 198px;
    height: 198px;
    display: flex;
}


.qrcodeBox img {
    height: 140px;
    width: 140px;
}


/deep/ .selectContentBox .el-checkbox__inner {
    margin-bottom: 15px !important;
}

/deep/ .input100 .el-input__inner {
    width: 100px;
}

/deep/ .input150 .el-input__inner {
    width: 150px;
}

/deep/ .input200 .el-input__inner {
    width: 200px;
}

/deep/ .input250 .el-input__inner {
    width: 250px;
}

/deep/ .input_h40 .el-input__inner {
    height: 40px;
}
</style>
